import { Component, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'app/services/application.service';
import { HeaderComponent } from 'app/components/header/header.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import {
    SlickCarouselComponent,
    SlickCarouselModule,
} from 'ngx-slick-carousel';
import moment from 'moment';
import { normalizeOrderedListContinuation } from 'app/shared/utils';

@Component({
    selector: 'app-news-details',
    standalone: true,
    imports: [
        CommonModule,
        HeaderComponent,
        FooterComponent,
        TranslateModule,
        MatIconModule,
        SlickCarouselModule,
    ],
    templateUrl: './news-details.component.html',
    styleUrl: './news-details.component.scss',
})
export class NewsDetailsComponent {
    private route = inject(ActivatedRoute);
    router = inject(Router);
    applicationService = inject(ApplicationService);
    selectedLanguage: any;
    isAuthenticated: boolean = false;
    currentSlide: number = 0;
    newsDetails: any;
    dataBM: any;
    dataEN: any;
    bannerStartDate: any;
    bannerMobileImages: any = [];
    bannerDesktopImages: any = [];
    newsId: any;
    formattedTitle3Desc: string = '';
    @ViewChild('slickModal') slickModal!: SlickCarouselComponent;
    @ViewChild('slickModalDesktop') slickModalDesktop!: SlickCarouselComponent;

    constructor(private activatedRoute: ActivatedRoute) {}

    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    ngOnInit() {
        this.selectedLanguage = this.readLocalStorageValue('language');

        this.activatedRoute.params.subscribe((params) => {
            this.newsId = params?.id;
            if (this.newsId) {
                this.getNewsDetails(this.newsId);
            }
        });
    }

    getNewsDetails(id: any) {
        this.applicationService.getCampaignDetailsById(id).subscribe({
            next: (data) => {
                let result = data;
                let newObj = {};

                if (
                    result?.campaigndetails &&
                    result?.campaigndetails?.length
                ) {
                    if (result?.campaigndetails[0]?.languages == 'BM') {
                        newObj = { ...result };
                        newObj['campaigndetails'] = result?.campaigndetails[0];
                        this.dataBM = newObj;
                    } else if (result?.campaigndetails[0]?.languages == 'EN') {
                        newObj = { ...result };
                        newObj['campaigndetails'] = result?.campaigndetails[0];
                        this.dataEN = newObj;
                    }

                    if (result?.campaigndetails[1]?.languages == 'BM') {
                        newObj = { ...result };
                        newObj['campaigndetails'] = result?.campaigndetails[1];
                        this.dataBM = newObj;
                    } else if (result?.campaigndetails[1]?.languages == 'EN') {
                        newObj = { ...result };
                        newObj['campaigndetails'] = result?.campaigndetails[1];
                        this.dataEN = newObj;
                    }
                }

                this.switchedLanguage(this.selectedLanguage);
            },
        });
    }

    readLocalStorageValue(key: string) {
        let value = localStorage.getItem(key);
        return value;
    }

    getDateWithFormat(data, locale) {
        return moment.utc(data).locale(locale).format('DD MMMM YYYY');
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    prevSlide() {
        this.slickModal.slickPrev();
    }

    nextSlide() {
        this.slickModal.slickNext();
    }

    prevSlideDesktop() {
        this.slickModalDesktop.slickPrev();
    }

    nextSlideDesktop() {
        this.slickModalDesktop.slickNext();
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;

        if (this.selectedLanguage == 'bm') {
            this.newsDetails = this.dataBM;
            this.bannerStartDate = this.getDateWithFormat(
                this.dataBM?.bannerStartDate,
                'ms-MY',
            );

            this.bannerMobileImages =
                this.dataBM?.campaigndetails?.bannerMobileImageUrlArray;
            this.bannerDesktopImages =
                this.dataBM?.campaigndetails?.bannerImageUrlArray;
            this.formattedTitle3Desc = normalizeOrderedListContinuation(
                this.dataBM?.campaigndetails?.title3Desc,
            );
        } else {
            this.newsDetails = this.dataEN;
            this.bannerStartDate = this.getDateWithFormat(
                this.dataEN?.bannerStartDate,
                'en-US',
            );

            this.bannerMobileImages =
                this.dataEN?.campaigndetails?.bannerMobileImageUrlArray;
            this.bannerDesktopImages =
                this.dataEN?.campaigndetails?.bannerImageUrlArray;
            this.formattedTitle3Desc = normalizeOrderedListContinuation(
                this.dataEN?.campaigndetails?.title3Desc,
            );
        }
    }
}
